import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
};

export const label: SxStyle = {
  fontSize: (p) => p.typography.caption,
  color: (p) => p.palette.common.black,
  fontWeight: 600, // TODO use typo
};
